import { createNgReactBridgeFactory } from '../../react-bridge'

/**
 * This is a legacy method that should only be used in the AngularJS layer.
 * Please avoid using this in new code. We should be aiming to remove this over time.
 * This is in the es6/TypeScript layer so that we can add tests since a considerable
 * amount of the legacy code still uses this method.
 *
 * This returns a promise-like object that can be cancelled via the `legacyCancelPromise` method.
 */
export const legacyMakeCancellableRequest = (
  $q: {
    readonly defer: angular.IQService['defer']
  },
  $http: (config: angular.IRequestConfig) => angular.IHttpPromise<unknown>,
  config: angular.IRequestConfig
) => {
  const _httpTimeout = $q.defer()
  const request = $http({
    ...config,
    timeout: _httpTimeout.promise
  })
  return Object.assign(request, { _httpTimeout })
}

/**
 * This is a legacy method that should only be used in the AngularJS layer.
 * Please avoid using this in new code. We should be aiming to remove this over time.
 * This is in the es6/TypeScript layer so that we can add tests since a considerable
 * amount of the legacy code still uses this method.
 *
 * This cancels (resolves) a promise-like object that is generated with the `legacyMakeCancellableRequest` method.
 */
export const legacyCancelPromise = (promise?: {
  readonly _httpTimeout?: {
    readonly resolve: () => void
  }
}) => {
  if (promise && promise._httpTimeout && promise._httpTimeout.resolve) {
    promise._httpTimeout.resolve()
  }
}

function PromiseServiceFactory() {
  return {
    cancelPromise: legacyCancelPromise
  }
}

createNgReactBridgeFactory('PromiseService', PromiseServiceFactory)
